export default {"src":"/_next/static/media/playStore_light_130x39.467686b4.svg","height":39,"width":130,"blurWidth":0,"blurHeight":0};